function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M41.0286 45.1558C38.953 43.2823 37.9175 40.8273 37.9175 37.7908C37.9175 34.7544 38.8894 32.5573 40.8992 30.8151C42.8431 29.0706 45.6977 28.1022 49.3924 27.7786L57.0432 27.2627C58.6646 27.1337 59.5071 26.2287 59.5071 24.6131C59.5071 22.9976 58.9893 21.8346 57.8857 20.9951C56.7843 20.2191 55.2264 19.8321 53.3484 19.8321C49.3289 19.8321 47.0602 21.511 46.606 24.8055H38.6305C39.0189 21.1241 40.445 18.2166 42.9748 16.2142C45.5024 14.2117 48.9405 13.2433 53.4142 13.2433C57.888 13.2433 61.4533 14.3407 63.9831 16.5377C66.447 18.7348 67.6779 22.0292 67.6779 26.3576V39.9879H70.3371V46.9637H67.0307C63.1406 46.9637 61.065 45.0246 60.8061 41.2143C58.7963 45.735 55.0357 47.9977 49.4606 47.9977C45.8952 47.9977 43.1065 47.0293 41.0332 45.1558H41.0286ZM57.2362 39.1484C58.7918 37.6619 59.5707 35.854 59.5707 33.657V32.365L51.1433 33.0099C47.8369 33.2678 46.2154 34.6887 46.2154 37.3383C46.2154 38.6303 46.6696 39.5987 47.5121 40.3092C48.3546 41.0197 49.5877 41.4066 51.1433 41.4066C53.6073 41.4066 55.617 40.6305 57.2385 39.1462L57.2362 39.1484Z",
  fill: "#282828"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M74.2886 22.5474C74.2886 19.8978 75.0016 17.832 76.4936 16.411C77.9198 14.9901 79.9954 14.2796 82.7818 14.2796H93.4143V21.2554H82.5865V46.9659H74.2886V22.5474Z",
  fill: "#282828"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M101.583 9.49864C100.091 9.49864 98.9235 9.0461 97.9515 8.14104C96.9796 7.30159 96.5254 6.13859 96.5254 4.781C96.5254 3.4234 97.0432 2.32601 98.0174 1.35759C98.9893 0.452531 100.157 0 101.583 0C103.009 0 104.242 0.452531 105.214 1.35759C106.186 2.32601 106.64 3.42566 106.64 4.781C106.64 6.13633 106.186 7.29933 105.214 8.14104C104.242 9.0461 103.075 9.49864 101.583 9.49864ZM97.4338 46.966V14.2796H105.732V46.966H97.4338Z",
  fill: "#282828"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M112.41 45.1558C110.335 43.2823 109.299 40.8273 109.299 37.7908C109.299 34.7544 110.271 32.5573 112.281 30.8151C114.225 29.0706 117.079 28.1022 120.774 27.7786L128.425 27.2627C130.046 27.1337 130.889 26.2287 130.889 24.6131C130.889 22.9976 130.371 21.8346 129.268 20.9951C128.166 20.2191 126.608 19.8321 124.73 19.8321C120.711 19.8321 118.442 21.511 117.988 24.8055H110.012C110.401 21.1241 111.827 18.2166 114.357 16.2142C116.884 14.2117 120.322 13.2433 124.796 13.2433C129.27 13.2433 132.835 14.3407 135.365 16.5377C137.829 18.7348 139.06 22.0292 139.06 26.3576V39.9879H141.719V46.9637H138.413C134.522 46.9637 132.447 45.0246 132.188 41.2143C130.178 45.735 126.418 47.9977 120.842 47.9977C117.277 47.9977 114.488 47.0293 112.415 45.1558H112.41ZM128.62 39.1484C130.176 37.6619 130.955 35.854 130.955 33.657V32.365L122.527 33.0099C119.221 33.2678 117.6 34.6887 117.6 37.3383C117.6 38.6303 118.054 39.5987 118.896 40.3092C119.739 41.0197 120.972 41.4066 122.527 41.4066C124.991 41.4066 127.001 40.6305 128.623 39.1462L128.62 39.1484Z",
  fill: "#282828"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M168.039 27.7786C168.039 22.8686 166.029 20.4136 162.01 20.4136C159.612 20.4136 157.665 21.2531 156.305 22.932C154.879 24.6765 154.166 27.2604 154.166 30.6838V46.9637H145.868V14.2796H153.389V19.0606C155.528 15.1846 159.03 13.2478 164.022 13.2478C167.846 13.2478 170.893 14.4108 173.099 16.6712C175.238 18.9972 176.339 22.1627 176.339 26.2309V46.9682H168.041V27.7831L168.039 27.7786Z",
  fill: "#282828"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M196.242 46.9659C192.417 46.9659 189.433 45.9318 187.36 43.9294C185.221 41.9269 184.183 39.1484 184.183 35.5327V21.2553H178.217V14.2795H182.042C183.792 14.2795 184.701 13.4401 184.701 11.6956V4.33063H192.286V14.2795H199.157V21.2553H192.479V38.051C192.479 39.343 193.126 39.9878 194.488 39.9878H200V46.9636H196.239L196.242 46.9659Z",
  fill: "#282828"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.5603 43.8073L0 1.74451H9.14045L21.6214 36.8112L34.0388 1.74451H43.311L27.6257 43.8231C26.6901 46.3347 24.2852 48 21.5965 48C18.9031 48 16.4937 46.3256 15.5626 43.8073H15.5603Z",
  fill: "#282828"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 200,
    height: 48,
    viewBox: "0 0 200 48",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

export default __webpack_public_path__ + "static/media/VariantLogo.4f5697f1.svg";
export { SvgComponent as ReactComponent };